/**
 * Team JS
 */

// CSS
import '../scss/team.scss';

// Vendors
import $ from 'jquery';

$('.slideshow-team').slick({
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./assets/js/team.js